import React, { memo, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { DesignPages } from './Edu/DesignPages';
import { AvatarPanel } from './UiKit/AvatarPanel';
import { Guide } from './UiKit/Guide';
import { MobGuide } from './UiKit/MobGuide';
import { PreloaderHD } from './UiKit/PreloaderHD';
import { UncertainContext, UncertainProvider } from '../contexts/uncertainContext';
import { WithRectification } from './WithRectification';
import { WithURLparams } from './WithURLparams';

export { NarrativesList } from './UiKit/NarrativesList';



// The hash carries several independent params (`n` narrative, `p` people panel,
// `g` group...), so it must be merged instead of overwritten.
const setHashParam = (key, value) => {
  const params = new URLSearchParams(window.location.hash.slice(1));
  if (params.get(key) === value) return;
  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }
  window.location.hash = params.toString();
};

const getHashParam = (key) => new URLSearchParams(window.location.hash.slice(1)).get(key);


export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; //assign the value of ref to the argument
  }, [value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
}






export function UncertainNarrativeBridge({ avatar, isMe, children }) {
  return (
    <UncertainProvider avatar={avatar} isMe={isMe}>
      {children}
    </UncertainProvider>
  );
}

export const Start = memo((props) => <StartInner {...props} />);

const StartInner = memo(({
  publ,
  user,
  avatar,
  penta,
  followings = [],
  followers = [],
  loading,
  children,
  isMe,
  refetch
}) => {


  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const uncertain = useContext(UncertainContext);
  const $ = context.$;
  const $ui = context.$ui;


  // console.log('avatar.design = ', avatar.design);


  // const narrative0 = context.narratives['empty'] ? context.narratives['empty'] : defaultNarrative;
  // const beginner = context.narratives['beginner'] ? context.narratives['beginner'] : defaultNarrative;
  // const pro = context.narratives['pro'] ? context.narratives['pro'] : defaultNarrative;



  const narrativeIds = Object.keys(context.narratives || {}).sort().join(',');

  useEffect(() => {
    const handleHashChange = () => {
      if (!context.me) return;
      const hashN = getHashParam('n');
      const ids = narrativeIds ? narrativeIds.split(',') : [];
      if (!ids.length) return;
      if (hashN === 'uncertain') return;
      if (hashN && ids.includes(hashN) && hashN !== context.narrativeCurrent) {
        context.setNarrativeCurrent(hashN);
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [narrativeIds, context.me]);

  // useEffect(() => {
  //   if (avatar && avatar.design['id'] === 'dummy') {
  //     context.setNarrativeCurrent('default');
  //   } else if (avatar) {
  //     context.setNarrativeCurrent('default');
  //   }
  // }, [context.narratives, avatar]);
  // useEffect(() => {
  //   if (
  //     avatar
  //     && avatar.design['id'] !== 'dummy'
  //     && context.narratives['pro']
  //   ) {
  //     context.setNarrativeCurrent('pro');
  //   } else if (avatar) {
  //     context.setNarrativeCurrent('default');
  //   }
  // }, [context.narratives, avatar]);

  // Keep the hash in sync for logged-in users. Unlogged view stays on
  // `public` without writing over the saved localStorage choice.
  const regularNarrativeId = context.narrativeCurrent === 'uncertain'
    ? 'simple'
    : context.narrativeCurrent;

  useEffect(() => {
    if (context.narrativeCurrent === 'uncertain') {
      context.setNarrativeCurrent('simple');
    }
  }, [context.narrativeCurrent]);

  useEffect(() => {
    if (!context.me || !regularNarrativeId || !avatar) return;
    setHashParam('n', regularNarrativeId);
  }, [regularNarrativeId, context.me, avatar]);


  useEffect(() => {
    // console.log('narrativeCurrent = ', context.narrativeCurrent);
    // console.log('narrativeCurrentN = ', context.narratives[context.narrativeCurrent]);
  }, [context.narrativeCurrent])


  const [scrollTo, setScrollTo] = useState(-1);

  const scrollToSection = (id) => {
    // setActiveLink(id)
    const section = document.getElementById(id);
    section && section.scrollIntoView({ behavior: "smooth" });
  };

  const designNarrative = avatar
    ? (avatar.design?.['id'] !== 'dummy'
      ? (context.me
        ? (
          uncertain?.available && uncertain.main === 'uncertain'
            ? (context.narratives.uncertain || context.narratives[regularNarrativeId] || context.narratives.simple)
            : (context.narratives[regularNarrativeId] || context.narratives.simple)
        )
        : (context.narratives['public'] || context.narratives['simple']))
      : context.narratives['default'])
    : null;

  const showGuide = Boolean(
    avatar
    && avatar.design
    && avatar.design['id'] !== 'dummy'
    && designNarrative
  );

  const navigate = useNavigate();
  const location = useLocation();
  const handleCloseInfoPop = () => {
    document.body.classList.remove('noscroll');
    context.setState.setHighlighted()
    context.setState.setSearch([])

    const removeStudySegments = (pathname) => {
      const segments = pathname.split('/study')
      return segments.length > 1 ? segments[0] : null
    };
    const currentPath = location.pathname;
    const newPath = removeStudySegments(currentPath);
    if (newPath) navigate(newPath);
  };

  const eduClassName = [
    'x_edu',
    context.state.calcShown ? 'x_edu--calc' : '',
    showGuide ? 'x_edu--mob-guide' : '',
    showGuide && context.me ? 'x_edu--mob-guide-menu' : '',
  ].filter(Boolean).join(' ');




  return (<>






    {avatar && <AvatarPanel
      publ={publ}
      isMe={isMe}
      user={user}
      avatar={avatar}
      followings={followings}
      followers={followers}
      refetch={refetch}
    />}

    {children}

    {/* {loading && <>
      <Preloader0 style={{ zIndex: 1, position: 'fixed', pointerEvents: 'none' }}>
        <Preloader width={80} height={80} />
      </Preloader0>
    </>} */}
    
    
    {loading && <> <PreloaderHD nologo /></>}


    <div
      style={{
        opacity: loading ? 0.2 : 1
        // marginRight: '-2em', paddingLeft: '2em'
      }}
      className={eduClassName}

    // style={{
    // opacity: datePickerShown ? 0.3 : 1,
    // overflow: datePickerShown ? 'hidden' : 'auto',
    // height: datePickerShown ? '100svh' : 'auto',
    // pointerEvents: datePickerShown ? 'none' : 'inherit',
    // }}
    >

      <div className={`x_edu_content00`}
      // onClick={() => handleCloseInfoPop()}
      >

        {
          !penta
          && avatar
          && <WithURLparams>
          <WithRectification avatar={avatar}>
            <DesignPages
              user={user}
              avatar={avatar}
                  narrative={
                    avatar.design['id'] !== 'dummy'
                      ? (context.me
                        ? (context.narratives[regularNarrativeId] || context.narratives['simple'])
                        : (context.narratives['public'] || context.narratives['simple']))
                      : context.narratives['default']
                  }
            //TODO: public date change
            // publ={publ}
            />
          </WithRectification>
        </WithURLparams>}

        {penta &&
          <DesignPages
            penta={penta}
          narrative={context.narratives['basic']}
          //TODO: public date change
          // publ={publ}
          />
        }

      </div>

    </div>




    {showGuide && <>
      <WithRectification avatar={avatar}>
        <Guide
          avatar={avatar}
          design={avatar.design}
          narrative={designNarrative}
          // activeLink={activeLink}
          scrollToSection={scrollToSection}
        />
      </WithRectification>
      <MobGuide narrative={designNarrative} hasMobMenu={Boolean(context.me)} />
    </>}

  </>
  )
})




